<template>
  <div class="d-flex flex-wrap mx-2">
    <v-checkbox
      v-model="download.jsonFiles"
      class="mr-2 my-1"
      label="Archivos JSON"
      hide-details="auto"
    ></v-checkbox>
    <v-checkbox
      v-if="TipoPlan != 'Contabilidad'"
      v-model="download.pdfFiles"
      class="mr-2 my-1"
      label="Archivos PDF"
      hide-details="auto"
    ></v-checkbox>

    <v-btn
      @click.stop="onClickDownload"
      color="primary"
      :disabled="loading || !data.length || !startDate || !endDate || (!download.jsonFiles && !download.pdfFiles)"
    >
      <v-icon left>mdi-download</v-icon>
      {{ loading ? 'Procesando...' : `Descargar ${data.length} comprobante${data.length !== 1 ? 's' : ''}` }}
    </v-btn>

    <div v-if="loading" class="w-100 mt-3">
      <v-progress-linear :value="progress" height="20" color="primary">
        <strong>{{ Math.ceil(progress) }}%</strong>
      </v-progress-linear>
      <div class="text-center mt-2">
        Procesando {{ currentInvoice }} de {{ totalInvoices }} comprobantes
      </div>
    </div>

    <div v-if="processingStatus.length > 0" class="w-100 mt-3">
      <v-expansion-panels v-model="showProcessingDetails">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-format-list-bulleted</v-icon>
              <span>Estado de comprobantes ({{ getStatusSummary() }})</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="processing-list" style="max-height: 400px; overflow-y: auto;">
              <v-list dense>
                <v-list-item
                  v-for="status in processingStatus"
                  :key="status.invoice.ID_Invoice"
                  class="px-2"
                >
                  <v-list-item-avatar size="32">
                    <v-icon :color="getStatusColor(status.status)" size="20">
                      {{ getStatusIcon(status.status) }}
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="text-subtitle-2">
                      {{ status.invoice.IdentificacionNumeroControl || status.invoice.IdentificacionCodigoGeneracion }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption">
                      ID: {{ status.invoice.ID_Invoice }} |
                      Fecha: {{ status.invoice.IdentificacionFecEmi }} |
                      Estado: {{ status.invoice.FeMhEstado || 'N/D' }} |
                      Resultado: {{ getStatusText(status.status) }}
                      <span v-if="status.error" class="error--text ml-1">
                        - {{ status.error }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      v-if="status.status === 'failed'"
                      @click="retryInvoice(status.invoice)"
                      small
                      color="primary"
                      text
                    >
                      <v-icon small>mdi-refresh</v-icon>
                      Reintentar
                    </v-btn>
                    <v-btn
                      v-else-if="status.status === 'success'"
                      @click="downloadSingleInvoice(status.invoice)"
                      small
                      color="success"
                      text
                    >
                      <v-icon small>mdi-download</v-icon>
                      Descargar
                    </v-btn>
                    <v-progress-circular
                      v-else-if="status.status === 'processing' || status.status === 'retrying'"
                      indeterminate
                      size="20"
                      width="2"
                      color="primary"
                    ></v-progress-circular>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <alerts
      v-if="alert.show"
      @close_alert="closeAlert"
      @accept_alert="acceptAlert"
      :properties="alert"
    />

    <PrintLiquidacionesHidden
      v-if="currentDocType === '09' && currentInvoiceData"
      ref="printDcl"
      :dataProps="currentInvoiceData"
    />

    <PrintLiquidacionesClHidden
      v-if="currentDocType === '08' && currentInvoiceData"
      ref="printCl"
      :dataProps="currentInvoiceData"
      :invoices="currentRelatedInvoices"
    />
  </div>
</template>

<script>
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import Alerts from "@/components/Alerts";
import PrintLiquidacionesHidden from '../ReportsAndPrintings/PrintLiquidacionesHidden.vue';
import PrintLiquidacionesClHidden from '../ReportsAndPrintings/PrintLiquidacionesClHidden.vue';

export default {
  name: "PrintPdfLiquidacionesProgrammatic",
  components: {
    Alerts,
    PrintLiquidacionesClHidden,
    PrintLiquidacionesHidden,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      currentDocType: null,
      currentInvoice: 0,
      currentInvoiceData: null,
      currentRelatedInvoices: [],
      download: {
        jsonFiles: false,
        pdfFiles: false,
      },
      loading: false,
      processingStatus: [],
      progress: 0,
      showProcessingDetails: false,
      totalInvoices: 0,
      TipoPlan: JSON.parse(localStorage.getItem("user"))?.TipoPlan || null,
    };
  },
  methods: {
    onClickDownload() {
      this.showAlert(
        "question2",
        "Confirmar descarga",
        "¿Está seguro que desea proceder con la descarga? Este proceso puede tomar varios minutos dependiendo de la cantidad de comprobantes.",
        "download"
      );
    },
    async acceptAlert() {
      this.alert.show = false;
      if (this.alert.options === "download") {
        await this.downloadZip();
      }
    },
    closeAlert() {
      this.alert.show = false;
    },
    showAlert(type, header, body, options = null) {
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options;
    },
    initializeProcessingStatus() {
      this.processingStatus = this.data.map(invoice => ({
        invoice,
        status: 'pending',
        error: null,
        generatedFiles: null,
      }));
    },
    updateInvoiceStatus(invoiceId, status, error = null, generatedFiles = null) {
      const index = this.processingStatus.findIndex(item => item.invoice.ID_Invoice === invoiceId);
      if (index !== -1) {
        this.$set(this.processingStatus, index, {
          ...this.processingStatus[index],
          status,
          error,
          generatedFiles: generatedFiles ?? this.processingStatus[index].generatedFiles,
        });
      }
    },
    getStatusSummary() {
      const total = this.processingStatus.length;
      const success = this.processingStatus.filter(s => s.status === 'success').length;
      const failed = this.processingStatus.filter(s => s.status === 'failed').length;
      const processing = this.processingStatus.filter(s => s.status === 'processing').length;
      return processing > 0
        ? `${success} exitosos, ${failed} fallidos, ${processing} procesando`
        : `${success} exitosos, ${failed} fallidos de ${total}`;
    },
    getStatusColor(status) {
      return { pending: 'grey', processing: 'blue', success: 'green', failed: 'red' }[status] || 'grey';
    },
    getStatusIcon(status) {
      return {
        pending: 'mdi-clock-outline',
        processing: 'mdi-loading',
        success: 'mdi-check-circle',
        failed: 'mdi-alert-circle'
      }[status] || 'mdi-help-circle';
    },
    getStatusText(status) {
      return {
        pending: 'Pendiente',
        processing: 'Procesando',
        success: 'Exitoso',
        failed: 'Falló'
      }[status] || 'Desconocido';
    },
    buildZipFilename() {
      const [startDay, startMonth, startYear] = (this.startDate || '').split('/');
      const [endDay, endMonth, endYear] = (this.endDate || '').split('/');
      const formattedStart = startDay && startMonth && startYear ? `${startYear}-${startMonth}-${startDay}` : 'inicio';
      const formattedEnd = endDay && endMonth && endYear ? `${endYear}-${endMonth}-${endDay}` : 'fin';
      return `comprobantes_liquidacion_${formattedStart}_a_${formattedEnd}.zip`;
    },
    sanitizeFilenamePart(value) {
      return String(value || '').replace(/[\\/:*?"<>|]/g, '').replace(/\s+/g, '_').trim();
    },
    buildPdfFileName(invoice, generatedFilename) {
      if (generatedFilename) return generatedFilename;
      const invoiceId = this.sanitizeFilenamePart(invoice.ID_Invoice);
      const numeroControl = this.sanitizeFilenamePart(invoice.IdentificacionNumeroControl);
      return `${invoiceId}_${numeroControl || invoice.IdentificacionCodigoGeneracion}.pdf`;
    },
    buildJsonFileName(invoice) {
      const invoiceId = this.sanitizeFilenamePart(invoice.ID_Invoice);
      const numeroControl = this.sanitizeFilenamePart(invoice.IdentificacionNumeroControl);
      return `${invoiceId}_${numeroControl || invoice.IdentificacionCodigoGeneracion}.json`;
    },
    parseJsonSafely(value) {
      if (!value) {
        return null;
      }

      if (typeof value === 'string') {
        try {
          return JSON.parse(value);
        } catch (error) {
          console.warn('No se pudo parsear JSON del comprobante:', error);
          return null;
        }
      }

      return value;
    },
    generateJsonData(invoice) {
      const jsonMh = this.parseJsonSafely(invoice.JsonMh);

      if (!jsonMh) {
        return { error: 'El comprobante no contiene JsonMh valido.' };
      }

      const jsonMhSigned = this.parseJsonSafely(invoice.JsonMhSigned);
      const responseMhJson = this.parseJsonSafely(invoice.ResponseMhJson);
      const dteJson = jsonMh?.dteJson || jsonMh;

      if (!dteJson || typeof dteJson !== 'object') {
        return { error: 'El comprobante no contiene un dteJson valido.' };
      }

      const jsonToSend = { ...dteJson };
      const firmaElectronica = jsonMhSigned?.documento || "";
      const selloRecibido = responseMhJson?.selloRecibido || "";

      if (firmaElectronica) {
        jsonToSend.firmaElectronica = firmaElectronica;
      }

      if (selloRecibido) {
        jsonToSend.selloRecibido = selloRecibido;
      }

      delete jsonToSend.passwordPri;
      delete jsonToSend.password;

      return jsonToSend;
    },
    async buildFilesForInvoice(invoice) {
      let pdfBlob = null;
      let jsonBlob = null;
      let generatedFilename = null;

      if (this.download.pdfFiles) {
        const { blob, filename } = await this.generatePdfForInvoice(invoice);
        pdfBlob = blob;
        generatedFilename = filename;
      }

      if (this.download.jsonFiles) {
        const jsonData = this.generateJsonData(invoice);

        if (jsonData && !jsonData.error) {
          jsonBlob = new Blob([JSON.stringify(jsonData, null, 2)], {
            type: 'application/json'
          });
        } else if (!this.download.pdfFiles) {
          throw new Error(jsonData?.error || 'No se pudo generar el JSON del comprobante.');
        }
      }

      if (!pdfBlob && !jsonBlob) {
        throw new Error('No se genero ningun archivo para el comprobante.');
      }

      return {
        pdfBlob,
        jsonBlob,
        filenameBase: this.buildPdfFileName(invoice, generatedFilename).replace(/\.pdf$/i, ''),
      };
    },
    async retryInvoice(invoice) {
      try {
        this.updateInvoiceStatus(invoice.ID_Invoice, 'retrying', null, null);
        const generatedFiles = await this.buildFilesForInvoice(invoice);
        this.updateInvoiceStatus(invoice.ID_Invoice, 'success', null, generatedFiles);
        this.showAlert("success", "Reintento exitoso", `El comprobante ${invoice.ID_Invoice} se procesó correctamente.`);
      } catch (error) {
        console.error(`Error reintentando comprobante ${invoice.ID_Invoice}:`, error);
        this.updateInvoiceStatus(invoice.ID_Invoice, 'failed', error.message || 'Error al reintentar el comprobante', null);
        this.showAlert("warning", "Error", `No se pudo reprocesar el comprobante ${invoice.ID_Invoice}.`);
      } finally {
        this.currentInvoiceData = null;
        this.currentDocType = null;
        this.currentRelatedInvoices = [];
        await this.$nextTick();
      }
    },
    async downloadSingleInvoice(invoice) {
      try {
        const statusItem = this.processingStatus.find(s => s.invoice.ID_Invoice === invoice.ID_Invoice);

        if (!statusItem) {
          this.showAlert("warning", "Advertencia", "No se encontró el comprobante en el listado de procesamiento.");
          return;
        }

        let generatedFiles = statusItem.generatedFiles;

        if (!generatedFiles) {
          this.updateInvoiceStatus(invoice.ID_Invoice, 'retrying', null, null);
          generatedFiles = await this.buildFilesForInvoice(invoice);
          this.updateInvoiceStatus(invoice.ID_Invoice, 'success', null, generatedFiles);
        }

        const zip = new JSZip();
        let filesAdded = false;

        if (generatedFiles.pdfBlob && this.download.pdfFiles) {
          zip.file(`${generatedFiles.filenameBase}.pdf`, generatedFiles.pdfBlob);
          filesAdded = true;
        }

        if (generatedFiles.jsonBlob && this.download.jsonFiles) {
          zip.file(`${generatedFiles.filenameBase}.json`, generatedFiles.jsonBlob);
          filesAdded = true;
        }

        if (!filesAdded) {
          this.showAlert("warning", "Advertencia", "No hay archivos disponibles para descargar en este comprobante.");
          return;
        }

        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, `${generatedFiles.filenameBase}.zip`);
      } catch (error) {
        console.error(`Error descargando comprobante ${invoice.ID_Invoice}:`, error);
        this.showAlert("warning", "Error", `No se pudo descargar el comprobante ${invoice.ID_Invoice}.`);
      } finally {
        this.currentInvoiceData = null;
        this.currentDocType = null;
        this.currentRelatedInvoices = [];
        await this.$nextTick();
      }
    },
    async generatePdfForInvoice(invoice) {
      this.currentInvoiceData = invoice;
      this.currentDocType = invoice.IdentificacionTipoDte;
      this.currentRelatedInvoices = [];

      if (invoice.IdentificacionTipoDte == '08') {
        const related = await this.$API.liquidaciones.getInvoicesByDocRelated({ ID_Invoice: invoice.ID_Invoice });
        if (!related.length) {
          throw new Error('No se encontraron documentos relacionados para el comprobante.');
        }
        this.currentRelatedInvoices = related;
      }

      await this.$nextTick();

      if (this.currentDocType == '09') {
        return this.$refs.printDcl.generatePdfBlob();
      }

      return this.$refs.printCl.generatePdfBlob();
    },
    async downloadZip() {
      if (!this.data.length) {
        this.showAlert("warning", "Advertencia", "No se encontraron comprobantes para descargar en el rango seleccionado.");
        return;
      }

      if (!this.download.jsonFiles && !this.download.pdfFiles) {
        this.showAlert("warning", "Advertencia", "Seleccione al menos un tipo de archivo para descargar.");
        return;
      }

      this.loading = true;
      this.progress = 0;
      this.currentInvoice = 0;
      this.totalInvoices = this.data.length;
      this.initializeProcessingStatus();
      this.showProcessingDetails = 0;

      try {
        const zip = new JSZip();
        const pdfFolder = this.download.pdfFiles ? zip.folder("PDFs") : null;
        const jsonFolder = this.download.jsonFiles ? zip.folder("JSONs") : null;
        let successCount = 0;

        for (let index = 0; index < this.data.length; index++) {
          const invoice = this.data[index];
          this.currentInvoice = index + 1;
          this.progress = (index / this.data.length) * 100;
          this.updateInvoiceStatus(invoice.ID_Invoice, 'processing');

          try {
            const generatedFiles = await this.buildFilesForInvoice(invoice);

            if (generatedFiles.pdfBlob && pdfFolder) {
              pdfFolder.file(`${generatedFiles.filenameBase}.pdf`, generatedFiles.pdfBlob);
            }

            if (generatedFiles.jsonBlob && jsonFolder) {
              jsonFolder.file(`${generatedFiles.filenameBase}.json`, generatedFiles.jsonBlob);
            }

            this.updateInvoiceStatus(invoice.ID_Invoice, 'success', null, generatedFiles);
            successCount++;
          } catch (error) {
            console.error(`Error procesando comprobante ${invoice.ID_Invoice}:`, error);
            this.updateInvoiceStatus(invoice.ID_Invoice, 'failed', error.message || 'Error al generar archivos');
          } finally {
            this.currentInvoiceData = null;
            this.currentDocType = null;
            this.currentRelatedInvoices = [];
            await this.$nextTick();
          }
        }

        this.progress = 100;

        if (!successCount) {
          this.showAlert("warning", "Advertencia", "No se pudo generar ningun archivo para el rango seleccionado.");
          return;
        }

        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, this.buildZipFilename());
        this.showAlert("success", "Descarga exitosa", "Los comprobantes se descargaron correctamente.");
      } catch (error) {
        console.error('Error en descarga masiva de liquidaciones:', error);
        this.showAlert("danger", "Error al descargar", "Ha ocurrido un error al generar el archivo ZIP de comprobantes.");
      } finally {
        this.loading = false;
        this.progress = 0;
        this.currentInvoice = 0;
        this.totalInvoices = 0;
        this.currentInvoiceData = null;
        this.currentDocType = null;
        this.currentRelatedInvoices = [];
      }
    },
  }
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}

.processing-list {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fafafa;
}

.processing-list .v-list-item {
  border-bottom: 1px solid #e0e0e0;
}

.processing-list .v-list-item:last-child {
  border-bottom: none;
}
</style>
